<template>
  <v-app>
    <div class="main_header" justify="center">      
      <div style="float:left; padding: 5px;">
        <v-img                    
          contain
          src="./assets/karmalog3.png"
          transition="scale-transition"
          width="100px"      
          @click="$vuetify.goTo(0, null)"          
        /> 
      </div>             
      
      <div v-show="wide_windows" style="float:right">
        <v-btn text @click="$vuetify.goTo('#scoll_get', null)"><span class="mr-1 white--text">Get</span> </v-btn>
        <v-btn text @click="$vuetify.goTo('#scoll_why', null)"> <span class="mr-1 white--text">Why</span> </v-btn>
        <v-btn text @click="$vuetify.goTo('#scoll_now', null)"> <span class="mr-1 white--text">Now</span> </v-btn>
        <v-btn text @click="$vuetify.goTo('#scoll_next', null)"> <span class="mr-1 white--text">Next</span> </v-btn>
        <v-btn text @click="$vuetify.goTo('#scoll_about', null)"> <span class="mr-1 white--text">About</span> </v-btn>
        <v-btn text @click="$vuetify.goTo('#scoll_contact', null)"> <span class="mr-3 white--text">Contact</span> </v-btn>
      </div>

      <div v-show="!wide_windows">        
      </div>
    </div>
    <div>
      <v-row v-resize="onResize">      
      </v-row>
    </div>
    <div class="main_image">      
      <!-- <img src="./assets/main_image.png" align="center" width="100%"> -->      
        <v-img id="blinking"  src="./assets/main_image.png" :aspect-ratio="ratio" height="500px"/>       
    </div>    
    <v-main>
      <Content/>
    </v-main>

  
    <Conditions/>
     
  </v-app>
</template>

<script>
import Content from './components/Content';
import Conditions from './components/Conditions';

export default {
  name: 'App',
  components: {
    Content,
    Conditions,
  },

  mounted () {
      this.onResize()
  },
  data: () => ({
    dialog : false,
    dialog2 : false,
    windowSize: {
        x: 0,
        y: 0,
      },
    wide_windows : true,
    ratio : 1,
  }),

  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.ratio = window.innerWidth / window.innerHeight * 1.2;
      this.wide_windows = (window.innerWidth >= 640);
    },
  },
};
</script>


<style scoped>
  .main_header {   
  z-index: 100;
  padding: 7px;
  display:inline-block;
  position: fixed;  
  left: 0;
  top: 0;
  width:100%;
  height:50px;
  background: #110000CC;      
  } 

  .main_image { 
  position: absolute;    
  left: 0px;
  top: 0px;  
  width: 100%;  
  height:500px;
  background: #000000;
  } 

#blinking{
	-webkit-animation:blink 10s ease-in-out infinite alternate;
    -moz-animation:blink 10s ease-in-out infinite alternate;
    animation:blink 10s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
} 


</style>


